import * as Models from "../.";
export interface IAppStatusResponse {
  isAppOnline: boolean;
  appOfflineMessage: string;
}

export class AppStatusResponse implements IAppStatusResponse {
    isAppOnline: boolean;
    appOfflineMessage: string;
  }
